/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ReceptionConditionInfoScreenFlow {
  None = 'None',
  Booking = 'Booking',
  DropIn = 'DropIn',
  Messaging = 'Messaging',
  Navigation = 'Navigation'
}
